import React, { forwardRef } from 'react';
import classNames from 'classnames';

type ListboxOptionsProps = {
  isOpen: boolean;
  fullWidth?: boolean;
  children?: React.ReactNode;
};

export const ListboxOptions = forwardRef<HTMLUListElement, ListboxOptionsProps>(
  ({ isOpen, fullWidth, children, ...rest }, ref) => (
    <ul
      ref={ref}
      className={classNames(
        'absolute z-10 mt-1 bg-white max-h-60 py-2 rounded-lg text-sm overflow-auto shadow-md focus:outline-none',
        fullWidth ? 'w-full' : 'w-max min-w-full'
      )}
      hidden={!isOpen}
      {...rest}
    >
      {children}
    </ul>
  )
);
